$(document).ready(function(){

    //Accordions
    let allAccordionsSection = document.querySelectorAll('.new-accordion-wrap');
    if(allAccordionsSection){
        allAccordionsSection.forEach((accordionWrap) => {
            const accordionHeaders = accordionWrap.querySelectorAll('.accordion-header');

            accordionHeaders.forEach((header) => {
                header.addEventListener('click', () => {
                    const item = header.parentElement;
                    const isActive = item.classList.contains('active');

                    // Close all items inside *this accordion only*
                    accordionWrap.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('active'));

                    // If this wasn't active before, open it
                    if (!isActive) {
                        item.classList.add('active');
                    }
                });
            });
        });
    }

    // //differenceSlider slider
    // $("#differenceSlider").owlCarousel({
    //     loop: true,
    //     margin: 20,
    //     dots: true,
    //     nav: false,
    //     navText: [
    //     ``,
    //     ``
    //     ],
    //     autoplay: true,
    //     autoplayTimeout: 4000,
    //     autoplayHoverPause: true,
    //     responsive: {
    //         0: {
    //             items: 1.2,
    //             center: true,
    //         },
    //         600: {
    //             items: 2.1,
    //         },
    //         1000: {
    //             items: 2.5,
    //         },
    //         1200: {
    //             items: 3,
    //         }
    //     }
    // });

    // var $slider = $('#differenceSlider');
    // if ($slider.length && !$slider.hasClass('slick-initialized')) {
    //   $slider.slick({
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     infinite: true,
    //     arrows: false,
    //     dots: false,
    //     autoplay: true,
    //     autoplaySpeed: 0,
    //     speed: 6000,
    //     cssEase: 'linear',
    //     pauseOnHover: false,
    //     pauseOnFocus: false,
    //     swipe: false,
    //     touchMove: false,
    //     variableWidth: true,

    //     responsive: [
    //       {
    //         breakpoint: 1200,
    //         settings: { slidesToShow: 3 }
    //       },
    //       {
    //         breakpoint: 1000,
    //         settings: { slidesToShow: 2.5 }
    //       },
    //       {
    //         breakpoint: 600,
    //         settings: { slidesToShow: 1.2 }
    //       }
    //     ]
    //   });
    // }


    //newFeaturedCollectionSlider
    $("#newFeaturedCollectionSlider").owlCarousel({
        loop: true,
        margin: 20,
        dots: true,
        nav: false,
        navText: [
        ``,
        ``
        ],
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1.2,
                center: true,
            },
            600: {
                items: 2.2,
            },
            1000: {
                items: 3.5,
            },
            1200: {
                items: 4,
            }
        }
    });

    let faqWrapper = document.querySelectorAll('.faq-inner-wrapper');
    if(faqWrapper){
        faqWrapper.forEach(heading => {
        heading.addEventListener('click', (event) => {
            event.stopPropagation();
            const faqWrapper = heading.closest('.main-faq-wrapper');
            const textarea = faqWrapper.querySelector('.faq-textarea');
            const isActive = faqWrapper.classList.contains('active');
            // Remove 'active' class from all wrappers
            document.querySelectorAll('.main-faq-wrapper').forEach(el => {
                el.classList.remove('active');
                el.querySelector('.faq-textarea').style.maxHeight = null; // Collapse all
            });
            
            if (!isActive) {
                faqWrapper.classList.add('active');
                textarea.style.maxHeight = textarea.scrollHeight + "px"; // Expand the active one
            } else {
                faqWrapper.classList.remove('active');
                textarea.style.maxHeight = null; // Collapse it
            }
        });
        });
    }


    //Numbers Count function
    const section = document.querySelector(".new-numbers-with-text-wrap");
    if (!section) return;

    const counters = section.querySelectorAll(".iwt-text");
    let hasAnimated = false;

    const startCount = () => {
        if (hasAnimated) return;
        hasAnimated = true;

        counters.forEach(counter => {
        const target = parseInt(counter.textContent.replace("%", ""), 10);
        let current = 0;
        const speed = 20; // lower = faster

        counter.textContent = "0%";

        const updateCount = () => {
            if (current < target) {
            current++;
            counter.textContent = current + "%";
            setTimeout(updateCount, speed);
            } else {
            counter.textContent = target + "%";
            }
        };

        updateCount();
        });
    };

    const observer = new IntersectionObserver(
        entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
            startCount();
            observer.disconnect(); // run once only
            }
        });
        },
        {
        threshold: 0.5 // 50% visible
        }
    );

    observer.observe(section);



});//doc ready ends